/*
 * Assistant demande APA (section apa-demande).
 * Toutes les donnees restent en memoire dans la page : aucun envoi, aucun stockage.
 */
(function () {
  'use strict';

  var PDFLIB_SRC = 'https://cdn.jsdelivr.net/npm/pdf-lib@1.17.1/dist/pdf-lib.min.js';
  var PDFLIB_SRI = 'sha384-weMABwrltA6jWR8DDe9Jp5blk+tZQh7ugpCsF3JwSA53WZM9/14PjS5LAJNHNjAI';

  // Fiches de l'annuaire officiel pour-les-personnes-agees.gouv.fr (liste relevee sur le site le 12/10/2026).
  var DEPTS = {
    '01': 'ain-01', '02': 'aisne-02', '03': 'allier-03', '04': 'alpes-de-haute-provence-04', '05': 'hautes-alpes-05',
    '06': 'alpes-maritimes-06', '07': 'ardeche-07', '08': 'ardennes-08', '09': 'ariege-09', '10': 'aube-10',
    '11': 'aude-11', '12': 'aveyron-12', '13': 'bouches-du-rhone-13', '14': 'calvados-14', '15': 'cantal-15',
    '16': 'charente-16', '17': 'charente-maritime-17', '18': 'cher-18', '19': 'correze-19', '21': 'cote-dor-21',
    '22': 'cotes-darmor-22', '23': 'creuse-23', '24': 'dordogne-24', '25': 'doubs-25', '26': 'drome-26',
    '27': 'eure-27', '28': 'eure-et-loir-28', '29': 'finistere-29', '2a': 'corse-du-sud-2a', '2b': 'haute-corse-2b',
    '30': 'gard-30', '31': 'haute-garonne-31', '32': 'gers-32', '33': 'gironde-33', '34': 'herault-34',
    '35': 'ille-et-vilaine-35', '36': 'indre-36', '37': 'indre-et-loire-37', '38': 'isere-38', '39': 'jura-39',
    '40': 'landes-40', '41': 'loir-et-cher-41', '42': 'loire-42', '43': 'haute-loire-43', '44': 'loire-atlantique-44',
    '45': 'loiret-45', '46': 'lot-46', '47': 'lot-et-garonne-47', '48': 'lozere-48', '49': 'maine-et-loire-49',
    '50': 'manche-50', '51': 'marne-51', '52': 'haute-marne-52', '53': 'mayenne-53', '54': 'meurthe-et-moselle-54',
    '55': 'meuse-55', '56': 'morbihan-56', '57': 'moselle-57', '58': 'nievre-58', '59': 'nord-59',
    '60': 'oise-60', '61': 'orne-61', '62': 'pas-de-calais-62', '63': 'puy-de-dome-63', '64': 'pyrenees-atlantiques-64',
    '65': 'hautes-pyrenees-65', '66': 'pyrenees-orientales-66', '67': 'bas-rhin-67', '68': 'haut-rhin-68',
    '70': 'haute-saone-70', '71': 'saone-et-loire-71', '72': 'sarthe-72', '73': 'savoie-73', '74': 'haute-savoie-74',
    '75': 'paris-75', '76': 'seine-maritime-76', '77': 'seine-et-marne-77', '78': 'yvelines-78', '79': 'deux-sevres-79',
    '80': 'somme-80', '81': 'tarn-81', '82': 'tarn-et-garonne-82', '83': 'var-83', '84': 'vaucluse-84',
    '85': 'vendee-85', '86': 'vienne-86', '87': 'haute-vienne-87', '88': 'vosges-88', '89': 'yonne-89',
    '90': 'territoire-de-belfort-90', '91': 'essonne-91', '92': 'hauts-de-seine-92', '93': 'seine-saint-denis-93',
    '94': 'val-de-marne-94', '95': 'val-doise-95', '971': 'guadeloupe-971', '972': 'martinique-972',
    '973': 'guyane-973', '974': 'la-reunion-974', '976': 'mayotte-976',
    '69d': 'rhone-69d', '69m': 'metropole-de-lyon-69m'
  };
  var ANNUAIRE = 'https://www.pour-les-personnes-agees.gouv.fr/annuaire-departements/';
  var ANNUAIRE_LISTE = 'https://www.pour-les-personnes-agees.gouv.fr/departements/annuaire-departements';

  function deptFromCp(cp) {
    cp = String(cp || '').replace(/\D/g, '');
    if (cp.length !== 5) return null;
    if (cp.indexOf('97') === 0) return cp.slice(0, 3);
    if (cp.indexOf('20') === 0) return parseInt(cp, 10) < 20200 ? '2a' : '2b';
    return cp.slice(0, 2);
  }

  function deptLabel(code) {
    return code === '2a' ? '2A' : code === '2b' ? '2B' : code;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function track(name) {
    try { if (window.fbq) window.fbq('trackCustom', name); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, {}); } catch (e) {}
  }

  var pdfLibPromise = null;
  function loadPdfLib() {
    if (window.PDFLib) return Promise.resolve(window.PDFLib);
    if (pdfLibPromise) return pdfLibPromise;
    pdfLibPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = PDFLIB_SRC;
      s.integrity = PDFLIB_SRI;
      s.crossOrigin = 'anonymous';
      s.onload = function () { window.PDFLib ? resolve(window.PDFLib) : reject(new Error('pdf-lib')); };
      s.onerror = function () { pdfLibPromise = null; reject(new Error('pdf-lib')); };
      document.head.appendChild(s);
    });
    return pdfLibPromise;
  }

  // Fichier Shopify : on tente d'abord le chemin de la boutique (meme origine), puis le CDN.
  async function fetchCerfa(url) {
    var tries = [];
    var m = String(url).match(/cdn\.shopify\.com\/s\/files\/[^?]*\/files\/([^?]+)(\?.*)?$/);
    if (m) tries.push('/cdn/shop/files/' + m[1] + (m[2] || ''));
    tries.push(url);
    for (var i = 0; i < tries.length; i++) {
      try {
        var res = await fetch(tries[i]);
        if (res.ok) {
          var buf = await res.arrayBuffer();
          var head = new Uint8Array(buf.slice(0, 5));
          if (String.fromCharCode.apply(null, head) === '%PDF-') return buf;
        }
      } catch (e) {}
    }
    throw new Error('pdf');
  }

  function init(root) {
    var form = root.querySelector('[data-apa-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var btnPrev = root.querySelector('[data-apa-prev]');
    var btnNext = root.querySelector('[data-apa-next]');
    var btnSubmit = root.querySelector('[data-apa-submit]');
    var errBox = root.querySelector('[data-apa-error]');
    var result = root.querySelector('[data-apa-result]');
    var current = 0;
    var urls = [];
    var products = {};
    try { products = JSON.parse(root.querySelector('[data-apa-products]').textContent); } catch (e) {}

    /* ---------- lecture des reponses ---------- */
    function raw() {
      var d = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name) return;
        if (el.type === 'radio') { if (el.checked) d[el.name] = el.value; }
        else if (el.type === 'checkbox') d[el.name] = el.checked ? 'true' : 'false';
        else d[el.name] = (el.value || '').trim();
      });
      d.organisme = (window.ApaCerfa ? window.ApaCerfa.organisme(d) : 'departement');
      return d;
    }

    function test(expr, d) {
      // "a=x,y|b=z" : OU entre clauses, valeurs separees par des virgules
      return expr.split('|').some(function (clause) {
        var p = clause.split('=');
        return p[1].split(',').indexOf(d[p[0]] || '') > -1;
      });
    }

    function isShown(el) {
      while (el && el !== form) {
        if (el.hidden) return false;
        el = el.parentElement;
      }
      return true;
    }

    function refresh() {
      var d = raw();
      root.querySelectorAll('[data-show-if]').forEach(function (el) {
        el.hidden = !test(el.getAttribute('data-show-if'), d);
      });
      // si l'option "representant" est masquee, revenir sur "le demandeur lui-meme"
      var rep = form.querySelector('input[name=sign_qualite][value=representant]');
      if (rep && rep.checked && !isShown(rep)) form.querySelector('input[name=sign_qualite][value=mon_nom]').checked = true;
      var route = root.querySelector('[data-apa-route]');
      var answered = ['auto_lever', 'auto_habiller', 'auto_toilette', 'auto_manger'].every(function (k) { return d[k]; });
      if (route) {
        route.hidden = !answered;
        if (answered) {
          route.innerHTML = d.organisme === 'departement'
            ? '<strong>Le dossier ira au département</strong> pour une demande d\'APA.'
            : '<strong>Le dossier ira à la caisse de retraite</strong> (Accompagnement à domicile des personnes âgées). L\'APA concerne les personnes qui ont besoin d\'aide pour au moins 2 de ces gestes.';
        }
      }
      return d;
    }

    function activeSteps(d) {
      return steps.filter(function (s) {
        var c = s.getAttribute('data-step-if');
        return !c || test(c, d);
      });
    }

    function show(i) {
      var d = refresh();
      var list = activeSteps(d);
      current = Math.max(0, Math.min(i, list.length - 1));
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      list[current].classList.add('is-active');
      root.querySelector('[data-apa-current]').textContent = current + 1;
      root.querySelector('[data-apa-total]').textContent = list.length;
      root.querySelector('[data-apa-progress]').style.width = Math.round((current + 1) / list.length * 100) + '%';
      btnPrev.hidden = current === 0;
      var last = current === list.length - 1;
      btnNext.hidden = last;
      btnSubmit.hidden = !last;
      errBox.hidden = true;
      var top = root.getBoundingClientRect().top + window.scrollY - 20;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function validate(step) {
      var bad = [];
      var checkedGroups = {};
      step.querySelectorAll('input').forEach(function (el) {
        if (!isShown(el)) return;
        el.classList.remove('is-invalid');
        if (el.type === 'radio') {
          if (el.required && !checkedGroups[el.name]) {
            checkedGroups[el.name] = true;
            if (!step.querySelector('input[name="' + el.name + '"]:checked')) bad.push(el);
          }
          return;
        }
        var v = (el.value || '').trim();
        if (el.required && !v) { el.classList.add('is-invalid'); bad.push(el); return; }
        var n = el.getAttribute('data-digits');
        if (n && v && v.replace(/\D/g, '').length !== parseInt(n, 10)) { el.classList.add('is-invalid'); bad.push(el); return; }
        if (el.type === 'email' && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { el.classList.add('is-invalid'); bad.push(el); }
      });
      if (bad.length) {
        errBox.textContent = 'Merci de compléter ou corriger les champs signalés.';
        errBox.hidden = false;
        try { bad[0].focus({ preventScroll: false }); } catch (e) {}
        return false;
      }
      return true;
    }

    /* ---------- donnees pour le Cerfa ---------- */
    function buildData(d) {
      var o = {};
      var skipPrefixes = [];
      if (['marie', 'pacse', 'concubinage'].indexOf(d.situation) < 0) skipPrefixes.push('conj_');
      if (d.protection !== 'oui') skipPrefixes.push('prot_', 'protection_mesure');
      if (d.organisme !== 'departement') skipPrefixes.push('rp_', 'bien', 'mob', 'cmi_');
      if (d.autres_biens !== 'oui') skipPrefixes.push('bien');
      if (d.mobiliers !== 'oui') skipPrefixes.push('mob');
      if (!(d.recent === 'oui' || ['accueillant', 'residence_autonomie'].indexOf(d.dem_domicile) > -1)) skipPrefixes.push('anc_');

      // seuls les champs visibles comptent
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || !isShown(el)) return;
        if (el.type === 'radio' && !el.checked) return;
        if (skipPrefixes.some(function (p) { return el.name.indexOf(p) === 0; })) return;
        if (el.type === 'checkbox') return;
        if (el.value !== '') o[el.name] = el.value.trim();
      });
      if (o.protection === undefined && d.protection) o.protection = d.protection;

      if (d.organisme === 'departement' && d.rp_same === 'true') {
        o.rp_adresse = d.dem_adresse; o.rp_cp = d.dem_cp; o.rp_commune = d.dem_commune;
      }
      // signature
      if (d.sign_qualite === 'representant') {
        o.sign_civilite = d.sign_civilite_rep; o.sign_nom = d.sign_nom_rep; o.sign_prenom = d.sign_prenom_rep;
        o.sign_representant_de = [d.dem_prenom, d.dem_nom_usage || d.dem_nom].join(' ').trim();
      } else {
        o.sign_qualite = 'mon_nom';
        o.sign_civilite = d.dem_civilite; o.sign_nom = d.dem_nom_usage || d.dem_nom; o.sign_prenom = d.dem_prenom;
      }
      delete o.sign_civilite_rep; delete o.sign_nom_rep; delete o.sign_prenom_rep;
      if (!o.sign_lieu && d.dem_commune) o.sign_lieu = d.dem_commune;
      // certificat medical : identite du patient
      if (d.cert_prefill === 'true') {
        o.cert_nom = d.dem_nom; o.cert_nom_usage = d.dem_nom_usage; o.cert_prenom = d.dem_prenom;
        o.cert_naiss = d.dem_naiss; o.cert_adresse = d.dem_adresse; o.cert_cp = d.dem_cp; o.cert_commune = d.dem_commune;
      }
      if (o.dem_caisse !== 'autre') delete o.dem_caisse_autre;
      return o;
    }

    /* ---------- budget protections (memo) ---------- */
    function unitPrice(key) {
      var p = products[key];
      if (!p || !p.variants) return null;
      var best = null;
      p.variants.forEach(function (v) {
        var m = String(v.title).match(/\((\d+)\s*unit/i);
        if (!m || !v.available) return;
        var u = v.price / parseInt(m[1], 10);
        if (best === null || u < best) best = u;
      });
      return best;
    }

    function budget(d) {
      if (d.prot_usage !== 'oui') return null;
      var lines = [];
      var jourNb = parseInt(d.prot_jour_nb, 10) || 0;
      var nuitNb = parseInt(d.prot_nuit_nb, 10) || 0;
      if (d.prot_jour_type === 'culotte' || d.prot_jour_type === 'change') {
        var k = d.prot_jour_type === 'culotte' ? 'culotte' : 'quotidien';
        lines.push({ label: (k === 'culotte' ? 'Culottes absorbantes' : 'Changes complets') + ' (jour)', perDay: jourNb, key: k });
      }
      if (nuitNb > 0) lines.push({ label: 'Changes complets nuit', perDay: nuitNb, key: 'nuit' });
      if (d.prot_alese === 'true') lines.push({ label: 'Alèses jetables', perDay: 1, key: 'alese' });
      var total = 0;
      lines.forEach(function (l) {
        l.month = l.perDay * 30;
        var up = unitPrice(l.key);
        l.cost = up ? Math.round(up * l.month) : null;
        if (l.cost) total += l.cost;
      });
      return { lines: lines, total: total };
    }

    function euros(n) { return n.toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' €'; }

    async function buildMemo(PDFLib, d, b) {
      var doc = await PDFLib.PDFDocument.create();
      var page = doc.addPage([595.28, 841.89]);
      var font = await doc.embedFont(PDFLib.StandardFonts.Helvetica);
      var bold = await doc.embedFont(PDFLib.StandardFonts.HelveticaBold);
      var green = PDFLib.rgb(0.1, 0.23, 0.22);
      var grey = PDFLib.rgb(0.33, 0.33, 0.33);
      var y = 790;
      function wrap(text, f, size, width) {
        var words = String(text).split(' '); var out = []; var line = '';
        words.forEach(function (w) {
          var t = line ? line + ' ' + w : w;
          if (f.widthOfTextAtSize(t, size) > width) { if (line) out.push(line); line = w; } else line = t;
        });
        if (line) out.push(line);
        return out;
      }
      function text(t, opts) {
        opts = opts || {};
        var f = opts.bold ? bold : font; var size = opts.size || 10.5; var x = opts.x || 50;
        wrap(t, f, size, 495 - (x - 50)).forEach(function (l) {
          page.drawText(l, { x: x, y: y, size: size, font: f, color: opts.color || PDFLib.rgb(0.1, 0.1, 0.1) });
          y -= size + 4;
        });
        y -= opts.after || 0;
      }
      function bullet(t) { page.drawText('-', { x: 56, y: y, size: 10.5, font: font }); text(t, { x: 66 }); }

      var nom = [d.dem_prenom, d.dem_nom_usage || d.dem_nom].join(' ').trim();
      text('Mémo pour la visite d\'évaluation à domicile', { bold: true, size: 17, color: green, after: 2 });
      text('Demande d\'aides à l\'autonomie' + (nom ? ' de ' + nom : ''), { size: 11, color: grey, after: 12 });

      text('Pourquoi ce mémo ?', { bold: true, size: 12.5, color: green, after: 2 });
      text('Après réception du dossier, un professionnel vient au domicile évaluer l\'autonomie et les besoins, puis propose un plan d\'aide. Les protections contre les fuites peuvent être prises en compte dans ce plan : il faut le demander explicitement pendant la visite.', { after: 10 });

      text('Besoins à signaler pendant la visite', { bold: true, size: 12.5, color: green, after: 2 });
      var gestes = { auto_lever: 'se lever', auto_habiller: 's\'habiller', auto_toilette: 'faire sa toilette', auto_manger: 'manger' };
      var aide = Object.keys(gestes).filter(function (k) { return d[k] === 'non'; }).map(function (k) { return gestes[k]; });
      if (aide.length) bullet('Aide d\'une autre personne nécessaire pour : ' + aide.join(', ') + '.');
      if (b && b.lines.length) {
        bullet('Protections utilisées chaque jour : ' + b.lines.map(function (l) { return l.label.toLowerCase() + ' : ' + l.perDay; }).join(' ; ') + '.');
        bullet('Demander que l\'achat de protections soit intégré au plan d\'aide.');
      }
      bullet('Présenter les factures d\'achat de protections des derniers mois.');
      y -= 8;

      if (b && b.lines.length && b.total) {
        text('Budget mensuel estimé en protections', { bold: true, size: 12.5, color: green, after: 4 });
        b.lines.forEach(function (l) {
          var right = l.cost ? euros(l.cost) : 'n.c.';
          page.drawText(l.label + ' : ' + l.perDay + ' par jour, soit ' + l.month + ' par mois', { x: 56, y: y, size: 10.5, font: font });
          page.drawText(right, { x: 545 - bold.widthOfTextAtSize(right, 10.5), y: y, size: 10.5, font: bold });
          y -= 16;
        });
        page.drawLine({ start: { x: 56, y: y + 8 }, end: { x: 545, y: y + 8 }, thickness: 0.6, color: grey });
        var tot = euros(b.total) + ' par mois';
        page.drawText('Total estimé', { x: 56, y: y - 6, size: 11, font: bold });
        page.drawText(tot, { x: 545 - bold.widthOfTextAtSize(tot, 11), y: y - 6, size: 11, font: bold });
        y -= 26;
        var dt = new Date().toLocaleDateString('fr-FR');
        text('Estimation sur la base des tarifs en format économique de confort-sec.fr au ' + dt + ', 30 jours par mois. Le besoin réel peut varier.', { size: 9, color: grey, after: 10 });
      }

      text('Pour le médecin (certificat médical, pages 11 à 13)', { bold: true, size: 12.5, color: green, after: 2 });
      text('Le certificat est facultatif mais il aide l\'équipe à évaluer la situation. Il comporte une rubrique « Assurer l\'hygiène de l\'élimination urinaire » et « fécale » : pensez à en parler au médecin pour qu\'elle soit renseignée.', { after: 10 });

      text('À garder sous la main le jour de la visite', { bold: true, size: 12.5, color: green, after: 2 });
      ['Les ordonnances et comptes rendus médicaux récents', 'Les factures de protections et de matériel', 'La liste des aides déjà en place (aide à domicile, portage de repas, etc.)', 'Les coordonnées du proche qui accompagne'].forEach(bullet);

      page.drawText('Document préparé avec l\'assistant APA de confort-sec.fr. Il ne remplace pas le formulaire officiel.', { x: 50, y: 40, size: 8, font: font, color: grey });
      return doc.save();
    }

    /* ---------- ecran de resultat ---------- */
    function addrBlock(code) {
      var slug = DEPTS[code];
      var a = slug && window.APA_DEPT_ADDR && window.APA_DEPT_ADDR[code];
      if (!a) return '';
      var head = /^(Collectivit|M[ée]tropole)/.test(a.n) ? a.n : (a.n === 'Paris' ? 'Ville de Paris' : 'Conseil départemental (' + a.n + ')');
      if (a.ask) {
        return '<p class="apa__card-text">Dans ce département, l\'adresse d\'envoi dépend de la commune du demandeur.</p>' +
          '<p class="apa__addr-meta"><a href="' + ANNUAIRE + slug + '" target="_blank" rel="noopener">Voir l\'adresse pour votre commune sur l\'annuaire officiel</a></p>' +
          (a.t ? '<p class="apa__addr-meta">Téléphone : <a href="tel:' + esc(a.t.replace(/\s/g, '')) + '">' + esc(a.t) + '</a></p>' : '');
      }
      var lines = [head].concat(a.a.split(' - ')).concat([a.cp + ' ' + a.v]).filter(Boolean);
      var html = '<address class="apa__addr" data-apa-addr>' + lines.map(esc).join('<br>') + '</address>';
      html += '<p class="apa__addr-meta"><button type="button" class="apa__btn apa__btn--ghost apa__btn--small" data-apa-copy>Copier l\'adresse</button></p>';
      if (a.t) html += '<p class="apa__addr-meta">Téléphone : <a href="tel:' + esc(a.t.replace(/\s/g, '')) + '">' + esc(a.t) + '</a></p>';
      html += '<p class="apa__addr-meta"><a href="' + ANNUAIRE + slug + '" target="_blank" rel="noopener">Vérifier sur l\'annuaire officiel et voir si la demande en ligne est possible</a></p>';
      return html;
    }

    function caisseBlock(d) {
      var h = '<p class="apa__card-text"><strong>La caisse de retraite principale du demandeur</strong> (Accompagnement à domicile des personnes âgées).</p>';
      if (d.dem_caisse === 'msa') {
        h += '<div class="apa__addr">MSA du demandeur<br><span class="apa__addr-meta">En ligne depuis l\'espace privé msa.fr, ou par courrier à sa caisse MSA (adresse sur ses courriers MSA).</span></div>';
        h += '<p class="apa__addr-meta"><a href="https://www.msa.fr" target="_blank" rel="noopener">msa.fr</a></p>';
      } else if (d.dem_caisse === 'assurance_retraite' || d.dem_caisse === 'fonction_publique') {
        h += '<div class="apa__addr">Caisse régionale de l\'Assurance retraite (Carsat) du domicile<br><span class="apa__addr-meta">Par courrier. L\'adresse figure sur les courriers de retraite du demandeur, ou par téléphone au <a href="tel:3960">39 60</a>.</span></div>';
        h += '<p class="apa__addr-meta"><a href="https://www.lassuranceretraite.fr" target="_blank" rel="noopener">lassuranceretraite.fr, rubrique Contacts</a></p>';
      } else {
        h += '<div class="apa__addr">Caisse de retraite principale du demandeur<br><span class="apa__addr-meta">L\'adresse figure sur ses courriers de retraite.</span></div>';
      }
      h += '<p class="apa__card-text apa__card-text--small">Si l\'autonomie se dégrade, une demande d\'APA au département reste possible plus tard.</p>';
      return h;
    }

    function renderWhere(d) {
      var el = root.querySelector('[data-apa-where]');
      var html = '';
      if (d.organisme === 'departement') {
        var code = deptFromCp(d.dem_cp);
        if (code === '69') {
          html += '<p class="apa__card-text">Dans le Rhône, deux interlocuteurs selon la commune : la Métropole de Lyon ou le Département du Rhône.</p>';
          html += '<p class="apa__card-text"><strong>Métropole de Lyon :</strong></p>' + addrBlock('69m');
          html += '<p class="apa__card-text"><strong>Département du Rhône (hors Métropole) :</strong></p>' + addrBlock('69d');
        } else if (code && DEPTS[code] && window.APA_DEPT_ADDR && window.APA_DEPT_ADDR[code]) {
          html += addrBlock(code);
        } else {
          html += '<p class="apa__card-text">Au département de résidence du demandeur.</p><p class="apa__addr-meta"><a href="' + ANNUAIRE_LISTE + '" target="_blank" rel="noopener">Trouver l\'adresse sur l\'annuaire officiel</a></p>';
        }
        var anc = deptFromCp(d.anc_cp);
        if (anc && anc !== code && DEPTS[anc]) {
          html += '<p class="apa__card-text apa__card-text--small">Installé il y a moins de 3 mois ? Le département qui finance peut être celui de l\'ancienne adresse (' + esc(deptLabel(anc)) + ') : appelez-le pour vérifier.</p>';
        }
      } else {
        html += caisseBlock(d);
      }
      el.innerHTML = html;
      var cp = el.querySelector('[data-apa-copy]');
      if (cp) cp.addEventListener('click', function () {
        var txt = Array.prototype.map.call(el.querySelectorAll('[data-apa-addr]'), function (a) { return a.innerText; }).join('\n\n');
        (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () { cp.textContent = 'Adresse copiée'; }, function () { cp.textContent = 'Copie impossible'; });
      });
    }

    function renderSign(d) {
      var who = d.sign_qualite === 'representant' ? 'le représentant légal' : 'le demandeur';
      var title = root.querySelector('[data-apa-sign-title]');
      var text = root.querySelector('[data-apa-sign-text]');
      if (sig.signed) {
        title.textContent = 'Vérifier la signature page 9';
        text.innerHTML = 'La signature est déjà placée en bas de la page 9. Vérifiez-la sur la version imprimée. Si vous envoyez le dossier par courrier, vous pouvez aussi signer à la main à côté.';
      } else {
        title.textContent = 'Le signer page 9';
        text.innerHTML = '<strong>Signature de ' + who + '</strong> dans le cadre « Signature », en bas à droite de la page 9. Le nom, le lieu' + (d.sign_date ? ' et la date sont' : ' sont') + ' déjà remplis' + (d.sign_date ? '.' : ' : ajoutez la date du jour à la main.');
      }
    }

    function renderTodo(d) {
      var t = [];
      var couple = ['marie', 'pacse', 'concubinage'].indexOf(d.situation) > -1;
      if (d.organisme === 'departement') {
        t.push('Copie d\'une pièce d\'identité du demandeur (carte d\'identité recto verso, passeport ou livret de famille ; titre de séjour en cours de validité pour un ressortissant hors UE).');
        t.push('Un RIB au nom du demandeur.');
        t.push('Copie du dernier avis d\'imposition ou de non-imposition, toutes les pages' + (couple ? ', du demandeur et de son conjoint.' : '.'));
        t.push('Recommandé : faire remplir le certificat médical (pages 11 à 13) par le médecin et le joindre sous pli cacheté.');
        if (d.protection === 'oui') t.push('Copie de la décision de justice de mise sous protection.');
        if (d.rp_occupation === 'non_louee' || d.autres_biens === 'oui') t.push('Dernier avis de taxe foncière de chaque bien qui n\'est pas loué.');
        if (d.cmi_stationnement === 'oui' || d.cmi_priorite === 'oui' || d.cmi_renouvellement === 'oui') t.push('Pour la carte mobilité inclusion : le certificat médical est particulièrement utile.');
      } else {
        t.push('Copie du dernier avis d\'imposition ou de non-imposition, toutes les pages' + (couple ? ', du demandeur et de son conjoint.' : '.'));
        if (d.protection === 'oui') t.push('Copie de la décision de justice de mise sous protection.');
        if (d.dem_caisse === 'fonction_publique') t.push('Copie du titre ou brevet de pension et un RIB.');
        t.push('Si l\'APA a déjà été refusée par le département : copie de la décision de refus.');
        t.push('Pour une carte mobilité inclusion : la demande se fait à part, auprès de la MDPH (Cerfa 15692*01).');
      }
      root.querySelector('[data-apa-todo]').innerHTML = t.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
    }

    function renderShop(d) {
      var reco = [];
      var dependant = d.organisme === 'departement' || d.auto_lever === 'non';
      if (dependant) reco = ['nuit', 'alese'];
      else if (d.prot_jour_type === 'culotte') reco = ['culotte'];
      else reco = ['quotidien'];
      if (d.prot_usage === 'oui' && d.prot_alese === 'true' && reco.indexOf('alese') < 0) reco.push('alese');
      if (d.prot_usage === 'oui' && parseInt(d.prot_nuit_nb, 10) > 0 && reco.indexOf('nuit') < 0) reco.unshift('nuit');
      var box = root.querySelector('.apa__products');
      if (!box) return;
      var cards = Array.prototype.slice.call(box.querySelectorAll('[data-apa-product]'));
      cards.forEach(function (c) { c.classList.toggle('is-reco', reco.indexOf(c.getAttribute('data-apa-product')) > -1); });
      cards.sort(function (a, b) {
        var ia = reco.indexOf(a.getAttribute('data-apa-product')); var ib = reco.indexOf(b.getAttribute('data-apa-product'));
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      }).forEach(function (c) { box.appendChild(c); });
    }

    async function generate() {
      var d = refresh();
      var url = root.getAttribute('data-cerfa-url');
      btnSubmit.setAttribute('aria-busy', 'true');
      btnSubmit.textContent = 'Préparation du dossier…';
      try {
        if (!url) throw new Error('url');
        var PDFLib = await loadPdfLib();
        var bytes = await fetchCerfa(url);
        var sigPng = null;
        if (sig.signed) {
          var dataUrl = sig.canvas.toDataURL('image/png');
          var bin = atob(dataUrl.split(',')[1]); sigPng = new Uint8Array(bin.length);
          for (var bi = 0; bi < bin.length; bi++) sigPng[bi] = bin.charCodeAt(bi);
        }
        var filled = await window.ApaCerfa.fill(bytes, buildData(d), PDFLib, { signaturePng: sigPng });
        urls.forEach(function (u) { URL.revokeObjectURL(u); }); urls = [];
        var u1 = URL.createObjectURL(new Blob([filled], { type: 'application/pdf' })); urls.push(u1);
        root.querySelector('[data-apa-download]').href = u1;
        root.querySelector('[data-apa-open]').href = u1;
        renderSign(d);

        var memoLink = root.querySelector('[data-apa-memo]');
        var b = budget(d);
        var memo = await buildMemo(PDFLib, d, b);
        var u2 = URL.createObjectURL(new Blob([memo], { type: 'application/pdf' })); urls.push(u2);
        memoLink.href = u2; memoLink.hidden = false;

        renderWhere(d); renderTodo(d); renderShop(d);
        form.hidden = true; result.hidden = false; result.focus();
        window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
        track('apa_dossier_genere');
      } catch (e) {
        errBox.textContent = 'Le formulaire n\'a pas pu être généré. Vérifiez votre connexion puis réessayez. Si le problème continue, appelez-nous au 05 35 75 83 75.';
        errBox.hidden = false;
      } finally {
        btnSubmit.removeAttribute('aria-busy');
        btnSubmit.textContent = 'Générer mon dossier';
      }
    }

    /* ---------- evenements ---------- */
    form.addEventListener('change', function () { refresh(); });
    form.addEventListener('focusout', function (e) {
      var el = e.target;
      if (el.hasAttribute && el.hasAttribute('data-upper')) el.value = el.value.toUpperCase();
    });
    btnNext.addEventListener('click', function () {
      var list = activeSteps(raw());
      if (!validate(list[current])) return;
      if (current === 0) { track('apa_debut'); loadPdfLib().catch(function () {}); }
      show(current + 1);
    });
    btnPrev.addEventListener('click', function () { show(current - 1); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var list = activeSteps(raw());
      if (!validate(list[current])) return;
      generate();
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'submit') {
        e.preventDefault();
        if (!btnNext.hidden) btnNext.click();
      }
    });
    root.querySelector('[data-apa-edit]').addEventListener('click', function () {
      result.hidden = true; form.hidden = false; show(0);
    });
    // ---------- signature a l'ecran ----------
    var sig = { canvas: root.querySelector('[data-apa-sign]'), signed: false };
    if (sig.canvas) {
      var ctx = sig.canvas.getContext('2d');
      var drawing = false, last = null;
      ctx.lineWidth = 3.2; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#12245a';
      var pos = function (e) {
        var r = sig.canvas.getBoundingClientRect();
        return { x: (e.clientX - r.left) * sig.canvas.width / r.width, y: (e.clientY - r.top) * sig.canvas.height / r.height };
      };
      sig.canvas.addEventListener('pointerdown', function (e) { drawing = true; last = pos(e); sig.canvas.setPointerCapture(e.pointerId); e.preventDefault(); });
      sig.canvas.addEventListener('pointermove', function (e) {
        if (!drawing) return;
        var p = pos(e);
        ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke();
        last = p; sig.signed = true; sig.canvas.classList.add('is-signed');
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { sig.canvas.addEventListener(t, function () { drawing = false; }); });
      root.querySelector('[data-apa-sign-clear]').addEventListener('click', function () {
        ctx.clearRect(0, 0, sig.canvas.width, sig.canvas.height); sig.signed = false; sig.canvas.classList.remove('is-signed');
      });
    }

    // date de signature : aujourd'hui par defaut
    var sd = form.querySelector('input[name=sign_date]');
    if (sd && !sd.value) sd.value = new Date().toISOString().slice(0, 10);
    show(0);
  }

  function boot() { document.querySelectorAll('[data-apa]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
